import { GET_TEMPLATES } from './getTemplates';
import { GET_DEPARTMENTS } from './getDepartaments';
import { UPDATE_VO_BUSINESS_PROCESS_FLOWS } from './updateVOBPFs';
import { GET_VO_TEMPLATES_AND_STAGES } from './getVOTemplatesAndStages';
import { UPDATE_TEMPLATE_STAGES_FIELDS } from './updateTemplateStageFields';
import { CREATE_BUSINESS_PROCESS_FLOW_TEMPLATE } from './createBusinessProcessFlowTemplate';
import { UPDATE_BUSINESS_PROCESS_FLOW_TEMPLATE } from './updateBusinessProcessFlowTemplate';

export * from './types';

export const stagesApi = {
  fetchDepartments: GET_DEPARTMENTS,
  fetchTemplates: GET_TEMPLATES,
  fetchVOTemplatesAndStages: GET_VO_TEMPLATES_AND_STAGES,
  updateVOBusinessProcessFlows: UPDATE_VO_BUSINESS_PROCESS_FLOWS,
  createTemplate: CREATE_BUSINESS_PROCESS_FLOW_TEMPLATE,
  updateTemplate: UPDATE_BUSINESS_PROCESS_FLOW_TEMPLATE,
  updateTemplateStageFields: UPDATE_TEMPLATE_STAGES_FIELDS,
};
